import { Referral } from 'types-model-repository/types.d';

export interface TReferral extends Referral {}

export enum StatusesValuesEnum {
  active = 'active',
  called = 'called',
  'called-late' = 'called-late',
  scheduled = 'scheduled',
  'scheduled-late' = 'scheduled-late',
  incomplete = 'incomplete',
  expired = 'expired',
  cancelled = 'cancelled',
  pending = 'pending',
  'closed' = 'closed',
}
